import { render, staticRenderFns } from "./Carousel2Slide.vue?vue&type=template&id=238105e0&scoped=true&"
import script from "./Carousel2Slide.vue?vue&type=script&lang=js&"
export * from "./Carousel2Slide.vue?vue&type=script&lang=js&"
import style0 from "./Carousel2Slide.vue?vue&type=style&index=0&id=238105e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238105e0",
  null
  
)

export default component.exports